<odx-form-field [formGroup]="formGroup" [readonly]="disabled" [label]="label">
  <odx-select
    odxFormFieldControl
    [formControlName]="controlName"
    i18n-placeholder="@@selectLanguage.placeholder"
    placeholder="Sprache auswählen"
  >
    @for (language of localizedLanguageNames | odxAutocompleteSearchFilter; track $index) {
      <odx-select-option [value]="language" (click)="onSelect(language)">
        <odx-highlight [odxHighlightSearch]="searchInput.value" [text]="language">
          {{ language }}
        </odx-highlight>
      </odx-select-option>
    }
    <input
      #searchInput
      i18n-placeholder="@@selectLanguage.placeholder"
      placeholder="Sprache auswählen"
      [odxSelectSearchField]="noLanguageFoundMessage"
    />
  </odx-select>
</odx-form-field>
